import { inject, Injectable } from '@angular/core';
import { TosService } from '@libs/account/components';
import { AuthService } from '@libs/shared/auth';
import { ConsentManagerService } from '@libs/shared/services';
import { ActionLinkHandler } from '@libs/shared/ui';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CmsActionLinkHandler extends ActionLinkHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly consentManager: ConsentManagerService = inject(ConsentManagerService);
  private readonly tosService: TosService = inject(TosService);

  public override handle(type?: string): boolean {
    switch (type) {
      case 'privacy-settings':
        this.consentManager.showSettings();

        return true;
      case 'terms-of-service':
        // TODO: DCP-715 - Add a loader and user-facing error notification.
        return this.tosService.openCurrentTosDialog();
      case 'login':
        void firstValueFrom(this.authService.login());

        return true;
      case 'registration':
        void firstValueFrom(this.authService.register());

        return true;
      default:
        return false;
    }
  }
}
